import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Link,
  Alert,
  LinearProgress,
} from "@mui/material";
import { passwordRecovery } from "../../services/Access";
import { t } from "i18next";

export default function ForgotPassword(props) {
  const [email, setEmail] = useState("");
  const [sendMail, setSendMail] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClickSendMail = () => {
    if (!email) {
      setError("Por favor, insira um email"); /*trad */
      return;
    }
    setError("");
    setLoading(true);
    passwordRecovery({ email })
      .then(() => {
        setSendMail(true);
      })
      .catch((e) => {
        if (e.response?.data?.msg === "1") {
          setError("Formato do email inválido"); /*trad */
        } else if (e.response?.data?.msg === "2") {
          setError("Email não encontrado"); /*trad */
        } else {
          setError(
            "Erro ao enviar email, tente novamente mais tarde",
          ); /*trad */
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: 400 }}>
        <Card elevation={3}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
              }}
            >
              {sendMail ? (
                <>
                  <Typography variant="h6">{t("forgotPassword")}</Typography>
                  <Typography variant="body2">
                    {t("emailSent")} <strong>{email}</strong>.
                  </Typography>
                  <Typography variant="body2">
                    {t("notReceivedEmail")}{" "}
                    <Link href="#" onClick={handleClickSendMail}>
                      {t("resendEmail")}
                    </Link>
                    . {t("checkSpam")}
                  </Typography>
                </>
              ) : (
                <>
                  <Box>
                    <Typography variant="h6">{t("forgotPassword")}</Typography>
                    <br />
                    <Typography variant="body2">{t("enterEmail")}</Typography>
                  </Box>

                  <TextField
                    label={t("email")}
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleClickSendMail();
                      }
                    }}
                  />

                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleClickSendMail}
                    disabled={loading}
                  >
                    {t("confirm")}
                  </Button>
                  {loading && (
                    <Box sx={{ width: "100%" }}>
                      <LinearProgress />
                    </Box>
                  )}
                  {error && (
                    <Box sx={{ width: "100%" }}>
                      <Alert variant="outlined" severity="error">
                        {error}
                      </Alert>
                    </Box>
                  )}
                </>
              )}
            </Box>
          </CardContent>
        </Card>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Link
            href="#"
            underline="hover"
            onClick={() => (window.location.href = "/")}
          >
            <Typography variant="body2">{t("backToLogin")}</Typography>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
